// extracted by mini-css-extract-plugin
module.exports = {"NavItems":"NavItems_NavItems__2v8og"};